import React, { useState, useEffect } from 'react'
import { Panel, Row, form, Col, Input, SelectPicker, Icon, Button, DatePicker } from 'rsuite'
import { isValidators } from '../../../utils/ValidatorUtils'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../../constants/date'
import SearchButton from '../../../components/buttons/searchButton/SearchButton'
import DatePickerCustom from '../../../components/datePicker/DatePickerCustom'

export default function BookingManagementScholarsSearch({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  ControlLabel,
  control,
  setValue,
  clearErrors,
  getValues,
  ...props
}) {
  // const [formSchema, setFormSchema] = useState(props.schema)
  const [formSchema, setFormSchema] = useState(_schema)
  // console.log("tets",_schema)
  return (
    <>
      <Row>
        <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
          {formSchema.projectCode.label}
        </Col>
        <Col lg={8} md={8} sm={24} xs={24}>
          <Input
            name={formSchema.projectCode.name}
            defaultValue={formSchema.projectCode.value}
            inputRef={register(isValidators(formSchema.projectCode.validators))}
            placeholder={'กรุณากรอก' + formSchema.projectCode.label}
          />
        </Col>

        <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
          {formSchema.projectName.label}
        </Col>
        <Col lg={8} md={8} sm={24} xs={24}>
          <Input
            name={formSchema.projectName.name}
            defaultValue={formSchema.projectName.value}
            inputRef={register(isValidators(formSchema.projectName.validators))}
            placeholder={'กรุณากรอก' + formSchema.projectName.label}
          />
        </Col>
      </Row>
      <Row style={{ marginTop: 10 }}>
        <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
          {formSchema.startDateBooking.label}
        </Col>
        <Col lg={8} md={8} sm={24} xs={24}>
          <Controller
            key={formSchema.startDateBooking.name}
            name={formSchema.startDateBooking.name}
            control={control}
            rules={isValidators(formSchema.startDateBooking.validators)}
            render={(props) => {
              return (
                <DatePickerCustom 
                  {...props}
                />
                // <DatePicker
                //   format={DATE_PICKER_FORMAT}
                //   locale={LOCAL_DAY_TH}
                //   block
                //   oneTap
                //   value={props.value}
                //   onChange={(value) => {
                //     props.onChange(value)
                //   }}
                // />
              )
            }}
          />
        </Col>
        <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
          {formSchema.stopDateBooking.label}
        </Col>
        <Col lg={8} md={8} sm={24} xs={24}>
          <Controller
            key={formSchema.stopDateBooking.name}
            name={formSchema.stopDateBooking.name}
            control={control}
            rules={isValidators(formSchema.stopDateBooking.validators)}
            render={(props) => {
              return (
                <DatePickerCustom 
                  {...props}
                />
                // <DatePicker
                //   format={DATE_PICKER_FORMAT}
                //   locale={LOCAL_DAY_TH}
                //   block
                //   oneTap
                //   value={props.value}
                //   onChange={(value) => {
                //     props.onChange(value)
                //   }}
                // />
              )
            }}
          />
        </Col>
      </Row>

      <Row style={{ marginTop: 10 }}>
        <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
          {formSchema.bookingExpirationDate.label}
        </Col>
        <Col lg={8} md={8} sm={24} xs={24}>
          <Controller
            key={formSchema.bookingExpirationDate.name}
            name={formSchema.bookingExpirationDate.name}
            control={control}
            rules={isValidators(formSchema.bookingExpirationDate.validators)}
            render={(props) => {
              return (
                <DatePickerCustom 
                  {...props}
                />
                // <DatePicker
                //   format={DATE_PICKER_FORMAT}
                //   locale={LOCAL_DAY_TH}
                //   block
                //   oneTap
                //   value={props.value}
                //   onChange={(value) => {
                //     props.onChange(value)
                //   }}
                // />
              )
            }}
          />
        </Col>
        <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
          {formSchema.bookingExpirationStopDate.label}
        </Col>
        <Col lg={8} md={8} sm={24} xs={24}>
          <Controller
            key={formSchema.bookingExpirationStopDate.name}
            name={formSchema.bookingExpirationStopDate.name}
            control={control}
            rules={isValidators(formSchema.bookingExpirationStopDate.validators)}
            render={(props) => {
              return (
                <DatePickerCustom 
                  {...props}
                />
                // <DatePicker
                //   format={DATE_PICKER_FORMAT}
                //   locale={LOCAL_DAY_TH}
                //   block
                //   oneTap
                //   value={props.value}
                //   onChange={(value) => {
                //     props.onChange(value)
                //   }}
                // />
              )
            }}
          />
        </Col>
      </Row>

      <Row style={{ marginTop: 10 }}>
        <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
          {formSchema.nameEquipment.label}
        </Col>
        <Col lg={8} md={8} sm={24} xs={24}>
          <Input
            name={formSchema.nameEquipment.name}
            defaultValue={formSchema.nameEquipment.value}
            inputRef={register(isValidators(formSchema.nameEquipment.validators))}
            placeholder={'กรุณากรอก' + formSchema.nameEquipment.label}
          />
        </Col>

        <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
          {formSchema.typeEquipment.label}
        </Col>
        <Col lg={8} md={8} sm={24} xs={24}>
          <Controller
            name={formSchema.typeEquipment.name}
            control={control}
            defaultValue={formSchema.typeEquipment.value}
            rules={isValidators(formSchema?.typeEquipment?.validators)}
            render={(props) => {
              return (
                <SelectPicker
                  searchable={false}
                  data={formSchema.typeEquipment.options}
                  value={props.value}
                  block
                  placeholder="เลือก"
                  onChange={(value) => {
                    props.onChange(value)
                  }}
                />
              )
            }}
          />
        </Col>
      </Row>

      <Row style={{ marginTop: 10 }}>
        <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
          {formSchema.bookingName.label}
        </Col>
        <Col lg={8} md={8} sm={24} xs={24}>
          <Input
            name={formSchema.bookingName.name}
            defaultValue={formSchema.bookingName.value}
            inputRef={register(isValidators(formSchema.bookingName.validators))}
            placeholder={'กรุณากรอก' + formSchema.bookingName.label}
          />
        </Col>

        <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
          {formSchema.projectStatus.label}
        </Col>
        <Col lg={8} md={8} sm={24} xs={24}>
          <Controller
            name={formSchema.projectStatus.name}
            control={control}
            defaultValue={formSchema.projectStatus.value}
            rules={isValidators(formSchema?.projectStatus?.validators)}
            render={(props) => {
              return (
                <SelectPicker
                  searchable={false}
                  data={formSchema.projectStatus.options}
                  value={props.value}
                  block
                  placeholder="เลือก"
                  onChange={(value) => {
                    props.onChange(value)
                  }}
                />
              )
            }}
          />
        </Col>
      </Row>
      <Row style={{ marginTop: 30 }}>
        <Col lg={24} md={24} sm={24} xs={24}>
          <hr />
          <SearchButton
            disabled={false}
            // onClick={onSave}
          >
            ค้นหา
          </SearchButton>
        </Col>
      </Row>
    </>
  )
}
